import { render, staticRenderFns } from "./AppErrorBlock.vue?vue&type=template&id=6f807172"
import script from "./AppErrorBlock.vue?vue&type=script&lang=js"
export * from "./AppErrorBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports